/* TheMindMarket theme — interactions (v1.1) */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var mb = e.target.closest('[data-menu-toggle]');
    if (mb) { var nav = document.getElementById('mobile-nav'); if (nav) nav.classList.toggle('open'); return; }
    var fq = e.target.closest('.faq > button');
    if (fq) { fq.parentElement.classList.toggle('open'); }
    var th = e.target.closest('[data-thumb]');
    if (th) { pgSelect(pgThumbs().indexOf(th)); return; }
    var nv = e.target.closest('[data-pg-nav]');
    if (nv) { e.preventDefault(); pgStep(parseInt(nv.getAttribute('data-pg-nav'), 10)); }
  });

  /* ---------- product gallery: arrows, dots, swipe, keyboard ---------- */
  function pgThumbs() {
    return Array.prototype.slice.call(document.querySelectorAll('.pg-thumb'));
  }
  function pgSelect(i) {
    var thumbs = pgThumbs();
    if (i < 0 || i >= thumbs.length) { return; }
    var main = document.getElementById('pg-main-img');
    if (main) { main.src = thumbs[i].getAttribute('data-full'); }
    thumbs.forEach(function (t, n) { t.classList.toggle('active', n === i); });
    document.querySelectorAll('.pg-dot').forEach(function (d, n) {
      d.classList.toggle('active', n === i);
    });
  }
  function pgStep(step) {
    var thumbs = pgThumbs();
    if (thumbs.length < 2) { return; }
    var i = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
    if (i < 0) { i = 0; }
    pgSelect((i + step + thumbs.length) % thumbs.length);
  }
  function initGallery() {
    var main = document.querySelector('[data-pg-swipe]');
    if (!main) { return; }
    var x0 = null;
    main.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) { return; }
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { pgStep(dx < 0 ? 1 : -1); }
      x0 = null;
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { pgStep(-1); }
      if (e.key === 'ArrowRight') { pgStep(1); }
    });
  }

  /* scroll reveal */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { el.classList.add('reveal-init'); io.observe(el); });
  }

  /* header scroll state */
  function initHeader() {
    var h = document.querySelector('.site-header');
    if (!h) return;
    var onScroll = function () { h.classList.toggle('scrolled', window.scrollY > 12); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* sticky mobile buy bar on product pages */
  function initStickyBuy() {
    var bar = document.getElementById('sticky-buy');
    var anchor = document.getElementById('main-add');
    if (!bar || !anchor) return;
    var onScroll = function () {
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('show', r.bottom < 0 || r.top > window.innerHeight);
    };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    var proxy = document.getElementById('sticky-add');
    if (proxy) proxy.addEventListener('click', function () {
      var btn = anchor.querySelector('button[name="add"]'); if (btn) btn.click();
    });
  }

  if (document.readyState !== 'loading') { initReveal(); initHeader(); initStickyBuy(); initGallery(); }
  else document.addEventListener('DOMContentLoaded', function () { initReveal(); initHeader(); initStickyBuy(); initGallery(); });
})();
